// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  display: inline-block;
}
.badge.badge-success {
  background-color: #28a745;
  color: white;
}
.badge.badge-danger {
  background-color: #dc3545;
  color: white;
}
.badge.badge-primary {
  background-color: #007bff;
  color: white;
}
.badge.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.alert {
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.alert mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.alert.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}
.alert.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffe69c;
  color: #664d03;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px 24px;
  padding-top: 12px;
}

.detail-full {
  grid-column: 1/-1;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.detail-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #6c757d;
  letter-spacing: 0.5px;
}

.error-message {
  color: #721c24;
  background: #f8d7da;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 13px;
}

.log-console {
  background: #fff;
  color: #212529;
  font-family: "Cascadia Code", "Consolas", "Courier New", monospace;
  font-size: 12px;
  line-height: 1.55;
  padding: 10px 14px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.log-console::-webkit-scrollbar {
  width: 7px;
}
.log-console::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.log-console::-webkit-scrollbar-thumb {
  background: #ced4da;
  border-radius: 4px;
}

.log-line {
  padding: 1px 0;
  word-break: break-word;
  white-space: pre-wrap;
}

.log-placeholder {
  color: #adb5bd;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-assessment/ai-assessment-job-detail/ai-assessment-job-detail.component.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAAF;AAEE;EAAoB,yBAAA;EAA2B,YAAA;AAEjD;AADE;EAAoB,yBAAA;EAA2B,YAAA;AAKjD;AAJE;EAAoB,yBAAA;EAA2B,YAAA;AAQjD;AAPE;EAAoB,yBAAA;EAA2B,YAAA;AAWjD;;AAPA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAUF;AARE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;AAa3C;AAXE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAaJ;AAVE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAYJ;;AAPA;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EACA,iBAAA;AAUF;;AAPA;EACE,iBAAA;AAUF;;AAPA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAUF;;AAPA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AAUF;;AAPA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAUF;;AANA;EACE,gBAAA;EACA,cAAA;EACA,kEAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AASF;AAPE;EAAuB,UAAA;AAUzB;AATE;EAA6B,mBAAA;AAY/B;AAXE;EAA6B,mBAAA;EAAqB,kBAAA;AAepD;;AAZA;EACE,cAAA;EACA,sBAAA;EACA,qBAAA;AAeF;;AAZA;EACE,cAAA;EACA,kBAAA;AAeF","sourcesContent":["// Badge styles\n.badge {\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  display: inline-block;\n\n  &.badge-success   { background-color: #28a745; color: white; }\n  &.badge-danger    { background-color: #dc3545; color: white; }\n  &.badge-primary   { background-color: #007bff; color: white; }\n  &.badge-secondary { background-color: #6c757d; color: white; }\n}\n\n// Alert\n.alert {\n  padding: 12px 20px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  mat-icon { font-size: 20px; width: 20px; height: 20px; }\n\n  &.alert-danger {\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    color: #721c24;\n  }\n\n  &.alert-warning {\n    background-color: #fff3cd;\n    border: 1px solid #ffe69c;\n    color: #664d03;\n  }\n}\n\n// Detail grid\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 14px 24px;\n  padding-top: 12px;\n}\n\n.detail-full {\n  grid-column: 1 / -1;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.detail-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #6c757d;\n  letter-spacing: 0.5px;\n}\n\n.error-message {\n  color: #721c24;\n  background: #f8d7da;\n  border-radius: 4px;\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n// Log console\n.log-console {\n  background: #fff;\n  color: #212529;\n  font-family: 'Cascadia Code', 'Consolas', 'Courier New', monospace;\n  font-size: 12px;\n  line-height: 1.55;\n  padding: 10px 14px;\n  height: 400px;\n  overflow-y: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n\n  &::-webkit-scrollbar { width: 7px; }\n  &::-webkit-scrollbar-track { background: #f1f1f1; }\n  &::-webkit-scrollbar-thumb { background: #ced4da; border-radius: 4px; }\n}\n\n.log-line {\n  padding: 1px 0;\n  word-break: break-word;\n  white-space: pre-wrap;\n}\n\n.log-placeholder {\n  color: #adb5bd;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
